import * as PropTypes from 'prop-types'
import classNames from 'classnames'

import tooltipStyles from './Tooltip.css'

export class Tooltip extends React.PureComponent {

  static propTypes = {
    isActive: PropTypes.bool,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    positionX: PropTypes.oneOf(['left', 'right']),
    positionY: PropTypes.oneOf(['top', 'bottom'])
  }

  getPositionStyles (positionX, positionY) {
    return {
      top: (positionY === 'bottom') ? 'auto' : '40px',
      bottom: (positionY === 'bottom') ? '40px' : 'auto',
      transformOrigin: `${positionY} ${positionX}`,
      right: (positionX === 'right') ? 0 : 'auto'
    }
  }

  render () {
    const { title, description, positionX, positionY, isActive } = this.props

    return (
      <div
        className={classNames(tooltipStyles.container, { [tooltipStyles.containerAnimateIn]: isActive })}
        style={this.getPositionStyles(positionX, positionY)}
      >
        <strong className={tooltipStyles.title}>{title}</strong>
        <p className={tooltipStyles.description}>{description}</p>
      </div>
    )
  }
}
